import React from 'react'
import PropTypes from 'prop-types'
import NavLink from '../router/NavLink'
import MultiLangText from '../multilang/MultiLangText'
import ScrollArrow from '../scrollarrow/ScrollArrow'

import {TimelineMax,TweenMax,Power3,Power2,Power1,Back,Circ} from 'gsap'
import ScrollToPlugin from "gsap/ScrollToPlugin";
import SplitText from 'gsap/SplitText'


class AboutSection extends React.Component {


  constructor(){
    super()

    this.state = {
        textAnimationStarted: false,
        textAnimation_tl:null,

        topOfText: 0,
        showScrollArrow: false
    }

    this.scrollSpy = this.scrollSpy.bind(this)
    this.setUpTextAnimation = this.setUpTextAnimation.bind(this)
    this.setupLinkAnimation = this.setupLinkAnimation.bind(this)
    this.setState = this.setState.bind(this)
  }


  scrollSpy(){


      let windowScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      let topOfSection = (windowScrollY-this.refs.container.offsetTop);

      let topOfText = (topOfSection-this.refs.textContainer.offsetTop);

    //  this.setState({topOfText})

      //console.log(topOfSection);

      if(this.state.textAnimation_tl){
        if(topOfText>100 ){

            //console.log("Play");
            this.state.textAnimation_tl.play()
        }else if(topOfText){
            this.state.textAnimation_tl.reverse()
        }
      }

      if(this.state.linkAnimation_tl && this.refs.link){

        let topOfLink = (topOfSection-this.refs.link.offsetTop);

        //console.log(this.state.linkAnimation_tl.progress());
        if(topOfLink > 100){

            this.state.linkAnimation_tl.play()

        }else if(topOfLink < 100){
            this.state.linkAnimation_tl.reverse()
        }
      }


    //  window.requestAnimationFrame(this.scrollSpy);


  }


  setUpTextAnimation(){

      let textAnimation_tl = new TimelineMax({repeat:0})





        //console.log('textAnimation_tl',textAnimation_tl);
        //console.log('text',text);

        let copy = this.refs.textContainer

        let copySplitText = new SplitText(copy,{type:"lines"})
        let copyLines = copySplitText.lines


        //console.log('copyLines',this.refs.textContainer);

        // Animate Title
        textAnimation_tl.staggerFrom(copyLines, 1, {opacity:0}, .5, "+=.3");
        if(this.refs.line){
          textAnimation_tl.from(this.refs.line,1,{width:0},'-=.3')
        }


          textAnimation_tl.add(()=>{
              this.setState({showScrollArrow:true})
          },'-=.6')

        textAnimation_tl.pause();


        this.setState({textAnimation_tl})



  }

  setupLinkAnimation(){

      if(this.refs.link){
        let linkAnimation_tl = new TimelineMax({repeat:0})

        let link = this.refs.link;
        let innerLink = this.refs.link.querySelector('a')
            link.style.width = 'auto';

            linkAnimation_tl.from(link,.5,{width:0})
            linkAnimation_tl.from(innerLink,.5,{autoAlpha:0})

            linkAnimation_tl.add(()=>{
                link.style.width = 'auto';
            })
            linkAnimation_tl.pause();

            this.setState({linkAnimation_tl})

          }
  }



  componentDidMount(){
    this.setUpTextAnimation();
    this.setupLinkAnimation();
    this.scrollSpy();

    window.addEventListener('scroll',this.scrollSpy)
  }

  componentWillUnmount(){
      window.removeEventListener('scroll',this.scrollSpy)
      this.state.textAnimation_tl.kill();
  }


  render () {

        let item = this.props.item
        let index = this.props.index;
        let aboutContent = this.props.aboutContent;
        let extraLearnMoreButtonClass = (item.text.text_position.indexOf('bottom')!==-1)? ' move-to-top' : ''


        //console.log("AboutSection",item.text.h_dist,item.text.v_dist);

        let textPaddingStyle = {
            paddingTop: (item.text.v_dist+'%'),
            paddingBottom: (item.text.v_dist+'%'),
            paddingLeft: (item.text.h_dist+'%'),
            paddingRight: (item.text.h_dist+'%')

        }

        let textColourClass = item.text.text_colour

        let textPosition = item.text.text_position

        if(window.innerWidth < 480){

            textColourClass = item.text.mobile_text_colour

           textPosition = item.text.mobile_text_position
            textPaddingStyle = {
                paddingTop: (item.text.mobile_v_dist+'%'),
                paddingBottom: (item.text.mobile_v_dist+'%'),
                paddingLeft: (item.text.mobile_h_dist+'%'),
                paddingRight: (item.text.mobile_h_dist+'%')

            }
        }


      return(<div key={"about-row"+index} className="content-row scroll-anchor" ref="container">
          <div className="image">
              <div className="desktop desktop-full-browser">
                {(item.image.desktop)?
                    <div className="background-image" style={{backgroundImage:'url('+(item.image.desktop)+')'}} />
                : <div className="" />}
              </div>
              {(item.image.mobile || item.image.desktop)?
                <div className="mobile" style={{backgroundImage:'url('+((item.image.mobile)? item.image.mobile : item.image.desktop)+')'}} />
                : <div className="mobile full-browser" />
              }
          </div>
          <div className={"text "+textPosition} style={textPaddingStyle}>
            <div className={"inner-text "+((index===aboutContent.length-1)? ' last-row' : ' ')} >
              <div ref="textContainer">
              <MultiLangText className={textColourClass} text={item.text} />
              </div>
              {
                (index===aboutContent.length-1)?
                  <div ref="line" className="line" />
                  : null

                }

            </div>
          </div>
          {(item.link.length)?
              <div ref="link" className={"read-more-link "+item.link_position+extraLearnMoreButtonClass}>
                  <a href={item.link} target="_blank" ><MultiLangText text={item.link_label} /></a>
              </div>
            : null
          }


          <div className={(item.image.mobile || item.image.desktop)? 'light-arrow' : ' '}>
            {(this.state.showScrollArrow)?
                <ScrollArrow />
              : null
              }
            </div>





        </div>)


  }
}

export default AboutSection;



// WEBPACK FOOTER //
// ./src/modules/pages/AboutSection.js